// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"glacier-portable-refrigerator_productcontent__j1Mrk"};